module.exports={account_link_complete_message:"Nexon खाते को लिंक करना पूरा हुआ."};